import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import type { BookingLifecycleStatus } from "@/types";

interface BookingPartnerStatusInsightProps {
  status: BookingLifecycleStatus;
  className?: string;
}

/** Context callout for ABANDONED — payment never completed (backend terminal state). */
export function BookingPartnerStatusInsight({
  status,
  className,
}: BookingPartnerStatusInsightProps) {
  const { t } = useTranslation("bookings");

  if (status !== "ABANDONED") {
    return null;
  }

  return (
    <div
      role="status"
      className={cn(
        "overflow-hidden rounded-lg border border-surface-200 bg-surface-50 px-4 py-3",
        className,
      )}
    >
      <div className="flex gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-surface-200 bg-surface-0">
          <Clock className="h-4 w-4 text-surface-500" aria-hidden />
        </div>
        <div className="min-w-0 flex-1 space-y-1">
          <p className="text-sm font-semibold text-surface-900">
            {t("detail.statusInsight.abandonedTitle")}
          </p>
          <p className="text-[13px] leading-relaxed text-surface-600">
            {t("detail.statusInsight.abandonedDescription")}
          </p>
        </div>
      </div>
    </div>
  );
}
